import { Card, Col, Row } from 'antd';
import React, { useContext, useState } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import Title from 'components/atoms/Title';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import { RowTitles } from 'components/molecules/RowTitles';

import { ETypAdresy } from 'enums/lei/typAdresy';

const PlatebniInstrukce: React.FC = () => {
    //   const { navigateWorkaround } = useNavigateWorkaround();;
    const { lei } = useContext(Context);
    const [mena, setMena] = useState<'CZK' | 'EUR'>();
    const jeCZ =
        lei?.detailData?.spolecnost?.adresy?.filter(e => e.typadresy === ETypAdresy.LEGALADDRESS)[0].country === 'CZ';
    return (
        <Card
            title={
                <Title
                    level={4}
                    text={
                        lei?.selectedLei?.stavlei
                            ? 'LEI_PLATOBNE_INFO_TITLE_AKTUALIZACE'
                            : 'LEI_PLATOBNE_INFO_TITLE_PRIDELENI'
                    }
                />
            }
            style={{
                maxWidth: 700
            }}
        >
            <Row gutter={2} justify="space-between">
                <Col span={11}>
                    <RowTitles
                        secondParagraph={true}
                        firstText="LEI_PLATOBNE_INFO_SPECSYMBOL"
                        secondText={String(lei?.detailData?.platbaspe || '')}
                        style={{
                            flexDirection: 'column',
                            paddingBottom: '10px'
                        }}
                        span={24}
                        offset={0}
                    />
                </Col>
                <Col span={11}>
                    <RowTitles
                        secondParagraph={true}
                        firstText="LEI_PLATOBNE_INFO_VARSYMBOL"
                        secondText={String(lei?.detailData?.platbavar || '')}
                        style={{
                            flexDirection: 'column',
                            paddingBottom: '10px'
                        }}
                        span={24}
                        offset={0}
                    />
                </Col>

                {/* <Paragraph
                    style={{
                        padding: '30px 0px 6px 0px'
                    }}
                    text="LEI_PLATOBNE_INFO_TEXTCR"
                />*/}
                <Col
                    span={24}
                    style={{
                        marginTop: 20
                    }}
                >
                    <Paragraph text={'MENA'} strong={true} />
                </Col>
                <Col
                    span={24}
                    style={{
                        marginBottom: 26
                    }}
                >
                    <SelectComponent
                        notRequired={true}
                        name="mena"
                        onChange={val => setMena(val)}
                        data={[
                            {
                                value: 'CZK',
                                labelcz: 'CZK'
                            },
                            {
                                value: 'EUR',
                                labelcz: 'EUR'
                            }
                        ]}
                    />
                </Col>
                {mena && (
                    <>
                        <Col span={24}>
                            {mena === 'CZK' ? (
                                <RowTitles
                                    secondParagraph={true}
                                    firstText="LEI_PLATOBNE_INFO_AMOUNTCR"
                                    secondText={
                                        lei?.selectedLei?.stavlei &&
                                        !['CANCELLED', 'PENDING_ARCHIVAL', 'PENDING_VALIDATION'].includes(
                                            lei?.selectedLei?.stavlei
                                        )
                                            ? jeCZ
                                                ? '1373,00'
                                                : '1135,00'
                                            : jeCZ
                                              ? '1875,00'
                                              : '1 550,00'
                                    }
                                    style={{
                                        flexDirection: 'column',
                                        paddingBottom: '10px'
                                    }}
                                    span={24}
                                    offset={0}
                                />
                            ) : (
                                <RowTitles
                                    secondParagraph={true}
                                    firstText="LEI_PLATOBNE_INFO_AMOUNTSK"
                                    secondText={
                                        lei?.selectedLei?.stavlei &&
                                        !['CANCELLED', 'PENDING_ARCHIVAL', 'PENDING_VALIDATION'].includes(
                                            lei?.selectedLei?.stavlei
                                        )
                                            ? jeCZ
                                                ? '54,5'
                                                : '45'
                                            : jeCZ
                                              ? '78,5'
                                              : '65'
                                    }
                                    style={{
                                        flexDirection: 'column',
                                        paddingBottom: '10px'
                                    }}
                                    span={24}
                                    offset={0}
                                />
                            )}
                        </Col>
                        <Col span={11}>
                            <RowTitles
                                secondParagraph={true}
                                firstText="LEI_PLATOBNE_INFO_KODBANKY"
                                secondText={mena === 'CZK' ? '2700' : '1111'}
                                style={{
                                    flexDirection: 'column',
                                    paddingBottom: '10px'
                                }}
                                span={24}
                                offset={0}
                            />
                        </Col>
                        <Col span={11}>
                            <RowTitles
                                secondParagraph={true}
                                firstText="CISLO_UCTU"
                                secondText={mena === 'CZK' ? '2109682657' : '1237698018'}
                                style={{
                                    flexDirection: 'column',
                                    paddingBottom: '10px'
                                }}
                                span={24}
                                offset={0}
                            />
                        </Col>
                        {/* <Paragraph
                    style={{
                        padding: '30px 0px 6px 0px'
                    }}
                    text="LEI_PLATOBNE_INFO_TEXTSK"
                />*/}

                        <Col span={11}>
                            <RowTitles
                                secondParagraph={true}
                                firstText="IBAN"
                                secondText={mena === 'CZK' ? 'CZ8727000000002109682657' : 'SK1511110000001237698018'}
                                style={{
                                    flexDirection: 'column',
                                    paddingBottom: '10px'
                                }}
                                span={24}
                                offset={0}
                            />
                        </Col>
                        <Col span={11}>
                            <RowTitles
                                secondParagraph={true}
                                firstText="SWIFT"
                                secondText={mena === 'CZK' ? 'BACXCZPP' : 'UNCRSKBX'}
                                style={{
                                    flexDirection: 'column',
                                    paddingBottom: '10px'
                                }}
                                span={24}
                                offset={0}
                            />
                        </Col>

                        <Col span={11}>
                            <Row
                                style={{
                                    flexDirection: 'column',
                                    paddingBottom: '10px'
                                }}
                            >
                                <Col span={24}>
                                    <Title
                                        level={5}
                                        text="LEI_PLATOBNE_INFO_ADRESA"
                                        style={{
                                            fontSize: 16,
                                            marginBottom: 0
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <span>
                                        <p
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            <TranslateText>
                                                {mena === 'EUR'
                                                    ? 'LEI_PLATOBNE_INFO_ADRESA1_SK'
                                                    : 'LEI_PLATOBNE_INFO_ADRESA1_CZ'}
                                            </TranslateText>
                                        </p>
                                        {mena === 'EUR' && (
                                            <p
                                                style={{
                                                    margin: 0
                                                }}
                                            >
                                                <TranslateText>{'LEI_PLATOBNE_INFO_ADRESA2_SK'}</TranslateText>
                                            </p>
                                        )}
                                        <p
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            <TranslateText>
                                                {mena === 'EUR'
                                                    ? 'LEI_PLATOBNE_INFO_ADRESA3_SK'
                                                    : 'LEI_PLATOBNE_INFO_ADRESA3_CZ'}
                                            </TranslateText>
                                        </p>
                                        <p
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            <TranslateText>
                                                {mena === 'EUR'
                                                    ? 'LEI_PLATOBNE_INFO_ADRESA4_SK'
                                                    : 'LEI_PLATOBNE_INFO_ADRESA4_CZ'}
                                            </TranslateText>
                                        </p>
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                        <Col span={11}>
                            <Row
                                style={{
                                    flexDirection: 'column',
                                    paddingBottom: '10px'
                                }}
                            >
                                <Col span={24}>
                                    <Title
                                        level={5}
                                        text="LEI_PLATOBNE_INFO_PRIJEMCE"
                                        style={{
                                            fontSize: 16,
                                            marginBottom: 0
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <span>
                                        <p
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            <TranslateText>LEI_PLATOBNE_INFO_PRIJEMCE1</TranslateText>
                                        </p>
                                        <p
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            <TranslateText>LEI_PLATOBNE_INFO_PRIJEMCE2</TranslateText>
                                        </p>
                                        <p
                                            style={{
                                                margin: 0
                                            }}
                                        >
                                            <TranslateText>LEI_PLATOBNE_INFO_PRIJEMCE3</TranslateText>
                                        </p>
                                    </span>
                                </Col>
                            </Row>
                        </Col>
                    </>
                )}
            </Row>
        </Card>
    );
};

export default PlatebniInstrukce;
